module.exports = __webpack_public_path__ + "static/media/pdi-image-06.fb0cb127.svg";